import { Select } from "@repo/core/components/core/Select";
import { Controller } from "react-hook-form";

import { SelectControlledProps } from "./types";

export const SelectControlled = ({
  name,
  control,
  defaultValue,
  isRequired,
  onChange,
  ...props
}: SelectControlledProps) => {
  return (
    <Controller
      defaultValue={defaultValue}
      control={control}
      name={name}
      render={({
        field: { onChange: onChangeField, value },
        fieldState: { error },
        formState: { isValid, isSubmitted }
      }) => {
        return (
          <Select
            {...props}
            isInvalid={(isSubmitted && !isValid) || !!error?.message}
            isRequired={isRequired}
            errorMessage={error?.message || ""}
            onChange={(changeValue) => {
              onChangeField(changeValue);
              onChange?.(changeValue);
            }}
            value={value}
            name={name}
          />
        );
      }}
    />
  );
};
